import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { authApi } from '../api/auth';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);

    try {
      await authApi.forgotPassword(email);
      setIsSubmitted(true);
    } catch (err: unknown) {
      // Always show success message to not reveal if email exists
      setIsSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-layout">
      <Card className="auth-card">
        <div className="auth-header">
          <img src="/tallai-icon.png" alt="TallAI" />
          <h1>tall<b>ai</b></h1>
        </div>

        {isSubmitted ? (
          <div className="auth-success">
            <Message
              severity="success"
              text="If an account exists for that email, we've sent password reset instructions."
            />
            <Link to="/login" className="auth-link">
              Back to Sign In
            </Link>
          </div>
        ) : (
          <>
            <p className="auth-subtitle">
              Enter your email address and we'll send you instructions to reset your password.
            </p>

            {error && (
              <Message severity="error" text={error} className="form-error" />
            )}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="field">
                <label htmlFor="email">Email</label>
                <InputText
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  autoComplete="email"
                  disabled={isSubmitting}
                />
              </div>

              <Button
                type="submit"
                label={isSubmitting ? 'Sending...' : 'Send Reset Link'}
                icon="ms-out ms-out-mail"
                className="submit-button"
                disabled={isSubmitting}
                loading={isSubmitting}
              />
            </form>

            <Link to="/login" className="auth-link">
              Back to Sign In
            </Link>
          </>
        )}
      </Card>
    </div>
  );
};

export default ForgotPassword;
